/**
 * Een herbruikbare bevestigingsmodal, naar het ontwerp van de verwijder-bevestiging
 * in het voorraadbeheer (bv. ProductList.js) - vervangt window.confirm().
 *
 * @param {Object} props
 * @param {string} props.title
 * @param {React.ReactNode} props.message
 * @param {function} props.onConfirm
 * @param {function} props.onCancel
 * @param {string} [props.confirmLabel]
 * @param {string} [props.cancelLabel]
 * @param {boolean} [props.danger] - rood gestileerde bevestigingsknop (bv. voor verwijderen)
 * @param {boolean} [props.busy]
 */
export default function ConfirmModal({
  title,
  message,
  onConfirm,
  onCancel,
  confirmLabel = "Bevestigen",
  cancelLabel = "Annuleren",
  danger = false,
  busy = false,
}) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h2 className="text-xl font-bold mb-4">{title}</h2>
        <div className="mb-6 text-gray-700">{message}</div>
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 border rounded hover:bg-gray-100"
            disabled={busy}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={`px-4 py-2 text-white rounded disabled:bg-gray-400 ${
              danger ? "bg-red-600 hover:bg-red-700" : "bg-blue-600 hover:bg-blue-700"
            }`}
            disabled={busy}
          >
            {busy ? "Bezig..." : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
